import React from "react"

import { useTrialBlock } from "@/contexts/TrialBlockContext"

import TrialBlockCalendar from "./TrialBlockCalendar"
import TrialBlockFilters from "./TrialBlockFilters"
import TrialBlockPageHeader from "./TrialBlockPageHeader"
import TrialBlockReviewDialog from "./TrialBlockReviewDialog"
import TrialBlocksTable from "./TrialBlocksTable"

export const TrialBlocksContent: React.FC = () => {
  const { viewMode, setViewMode, selectedBlock } = useTrialBlock()

  return (
    <>
      <TrialBlockPageHeader
        viewMode={viewMode}
        setViewMode={setViewMode}
        showCreateButton={false}
      />

      <TrialBlockFilters />

      {viewMode === "calendar" ? <TrialBlockCalendar /> : <TrialBlocksTable />}

      {selectedBlock && <TrialBlockReviewDialog />}
    </>
  )
}

export default TrialBlocksContent
